import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlugCircleXmark, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import './ErrorState.scss';

export default function ErrorState({
    title = 'Une erreur est survenue',
    message = "Impossible de charger ces données pour le moment. Vérifiez votre connexion et réessayez.",
    onRetry,
    retryLabel = 'Réessayer',
}) {
    return (
        <div className="error-state">
            <div className="error-state__art">
                <span className="error-state__ring" />
                <span className="error-state__icon">
                    <FontAwesomeIcon icon={faPlugCircleXmark} />
                </span>
            </div>
            <h3 className="error-state__title">{title}</h3>
            <p className="error-state__message">{message}</p>
            {onRetry && (
                <button type="button" className="error-state__retry" onClick={onRetry}>
                    <FontAwesomeIcon icon={faRotateRight} />
                    {retryLabel}
                </button>
            )}
        </div>
    );
}
